
export default {
    getMessages: (state, getters, rootState) => {
        let messages = state.order.messages.filter((msg) => msg.message.toLowerCase().includes(state.messageSearchQuery.toLowerCase()))
        return messages;
    },
}
